import { Check, ContentCopyOutlined } from '@mui/icons-material';
import { IconButton, Tooltip as MuiTooltip } from '@mui/material';
import React, { useMemo } from 'react';

import { useCopyToClipboard } from 'new/elements/CodeEditorMode/hooks/useCopyToClipboard';
import { getLogsExportText } from 'new/elements/Button/logCopyText';
import { Log } from '../types';

interface LogCopyAllIconButtonProps {
  logs: Log[];
  title: string;
}

const checkComponentRef = <Check fontSize="large" />;
const copyComponentRef = <ContentCopyOutlined fontSize="large" />;

export const LogCopyAllIconButton = ({ logs, title }: LogCopyAllIconButtonProps) => {
  const clipboardText = useMemo(() => getLogsExportText(logs), [logs]);

  const { isCopied, copyToClipboard } = useCopyToClipboard(clipboardText);

  const hasNoLogsToCopy = logs.length === 0;
  const copyIcon = isCopied ? checkComponentRef : copyComponentRef;
  const tooltipTitle = isCopied ? 'Copied!' : title;

  const iconButton = (
    <IconButton
      size="large"
      aria-label={title}
      onClick={copyToClipboard}
      disabled={hasNoLogsToCopy}
    >
      {copyIcon}
    </IconButton>
  );

  return (
    <MuiTooltip title={tooltipTitle} arrow placement="top">
      {hasNoLogsToCopy ? <span>{iconButton}</span> : iconButton}
    </MuiTooltip>
  );
};
